React = require 'react'
t = require('views/internal/recup-with-helpers')()
l = require 'lib/localize'
_ = require 'underscore'
Auth = require 'db/auth'
SidebarState = require 'view-models/sidebar-state'
ModelLoader = require 'db/model-loader'
Payloads = require 'network/payloads'
Promise = require 'bluebird'
ApiError = require 'network/api-error'
HomeSectionHeaderComponent = require 'views/home/home-section-header-component'
HomeBoardSection = require 'views/home/home-board-section'
HomeBoardSectionLinks = require 'views/home/home-board-section-links'

module.exports = class HomeRightSidebarContainer extends React.Component
  displayName: 'HomeRightSidebarContainer'

  constructor: (props) ->
    @defaultNumStarredBoardsVisible = 8
    @defaultNumRecentBoardsVisible = 4

    @_idBoardsFetching = []
    @currentStarBoardList = props.model.boardStarList.getBoardIds()


    @state =
      starredBoards: []
      recentBoards: []
      showAllStarredBoards: false
      showAllRecentBoards: false

    @getBoards = @getBoards.bind(@)
    @fetchUnknownBoards = @fetchUnknownBoards.bind(@)
    @showBoards = @showBoards.bind(@)

  componentDidMount: ->
    @getBoards()

  componentWillReceiveProps: (nextProps) ->
    newStarBoardList = nextProps.model.boardStarList.getBoardIds()
    if !_.isEqual(@currentStarBoardList, newStarBoardList)
      @getBoards()

    @currentStarBoardList = newStarBoardList

  fetchUnknownBoards: (idBoards) ->
    { modelCache } = @props

    idBoardsMissing = _.chain idBoards
    .difference @_idBoardsFetching
    .reject (idBoard) => modelCache.get('Board', idBoard)?
    .value()

    return if idBoardsMissing.length == 0

    @_idBoardsFetching = @_idBoardsFetching.concat(idBoardsMissing)

    boards = idBoardsMissing.map (idBoard) =>
      ModelLoader.loadBoardData idBoard, Payloads.boardMinimal
      .catch ApiError.NotFound, ApiError.Unauthorized, ->
        SidebarState.pullBoard(idBoard)

    Promise.all boards
    .then =>
      @_idBoardsFetching = _.difference @_idBoardsFetching, idBoardsMissing
      return
    .done()

  getBoards: ->
    { model, modelCache } = @props

    ModelLoader.waitFor 'boardsData', =>
      me = Auth.me()

      starredBoards = _.filter(model.boardStarList.getBoards(), (board) => board?.isOpen() && board?.isViewableBy(me))

      recentBoards = _.chain SidebarState.getRecentBoards()
        .tap (idBoards) => @fetchUnknownBoards(idBoards)
        .map (idBoard) => modelCache.get('Board', idBoard)
        .compact()
        .filter (board) => board?.isOpen() && board?.isViewableBy(me)
        .value()

      @setState (prevState, props) ->
        starredBoards: starredBoards
        recentBoards: recentBoards

  showBoards: (boardType, showAll) ->
    if boardType == 'starred'
      @setState showAllStarredBoards: showAll
    else if boardType == 'recent'
      @setState showAllRecentBoards: showAll

  render: t.renderable ->
    { model, modelCache, orgname } = @props
    {
      starredBoards
      recentBoards
      showAllRecentBoards
      showAllStarredBoards
    } = @state

    t.div '.home-right-sidebar-container', =>
      if starredBoards.length
        t.tag HomeSectionHeaderComponent, {
          title: l('home board section title.starred')
          iconClass: 'star'
        }
        t.tag HomeBoardSection, {
          boards: starredBoards
          showOrgName: true
          numBoardsVisible: @defaultNumStarredBoardsVisible
          showAll: showAllStarredBoards
          onShowMoreClick: => @showBoards('starred', true)
          onShowFewerClick: => @showBoards('starred', false)
        }

      if recentBoards.length
        t.tag HomeSectionHeaderComponent, {
          title: l('home board section title.recent')
          iconClass: 'clock'
        }
        t.tag HomeBoardSection, {
          boards: recentBoards
          showOrgName: true
          numBoardsVisible: if starredBoards.length < 4 then 8 else @defaultNumRecentBoardsVisible
          showAll: showAllRecentBoards
          onShowMoreClick: => @showBoards('recent', true)
          onShowFewerClick: => @showBoards('recent', false)
        }

      t.tag HomeSectionHeaderComponent, {
        title: l('home board section title.links')
      }
      t.tag HomeBoardSectionLinks, {
        modelCache
        orgname
      }



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-right-sidebar-container.coffee